module.exports = __webpack_public_path__ + "img/workforce-analytics.137895f3.png";